
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Captures d'écran de l'app «SwissCovid»: Si le test est positif, le «code covid»
à 12 chiffres doit être entré pour déclencher la notification`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;